import React, { useReducer } from "react";
import DE from "../translations/de.json";
import FR from "../translations/fr.json";
import IT from "../translations/it.json";
import { getLanguage, setDefaultLanguageWithReturn } from "../utils/locale";

const DEFAULT_LANGUAGE = "de";
export const translations = {
  fr: FR,
  it: IT,
  de: DE
};

const findTranslation = (languageCode, keyPath) => {
  const keyParts = keyPath.split(".");
  const isLastPartOfJsonPath = index => keyParts.length - 1 === index;

  try {
    return keyParts.reduce((acc, key, index) => {
      const isString = key.toString() === key;
      const hasKey = acc[key];
      const hasFoundNonStringValue = !isString && isLastPartOfJsonPath(index);

      if (!hasKey || hasFoundNonStringValue) {
        throw new Error("Translation Not Found");
      }

      return acc[key];
    }, translations[languageCode]);
  } catch (e) {
    return null;
  }
};

const getTranslate = languageCode => keyPath => {
  const translation = findTranslation(languageCode, keyPath);

  if (!translation) {
    return findTranslation(DEFAULT_LANGUAGE, keyPath) || keyPath;
  }

  return translation;
};

const langCode = getLanguage() || setDefaultLanguageWithReturn();

const initialState = {
  langCode,
  t: getTranslate(langCode)
};

export const I18nContext = React.createContext(initialState);

const SET_LANGUAGE = "SET_LANGUAGE";

export const I18nContextProvider = ({ children }) => {
  const reducer = (state, action) => {
    switch (action.type) {
      case SET_LANGUAGE:
        return {
          langCode: action.payload,
          t: getTranslate(action.payload)
        };
      default:
        return { ...initialState };
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <I18nContext.Provider value={{ ...state, dispatch }}>
      {children}
    </I18nContext.Provider>
  );
};
